import { Form } from 'factorial-form'

class ManualIncidenceForm extends Form {
  constructor(values: object) {
    super(values, {
      id: 'number',
      legal_entity_id: 'number',
      subject: 'string',
      description: 'string',
      effective_on: 'date',
      employee_id: 'number',
    })
  }
}

export default ManualIncidenceForm
